import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  template: `
<registration-page centered="true">
    <h1>Oops</h1>
    <p>We've encountered a problem setting up your account, please call us 0800 80 70 70.</p>
</registration-page>
`
})
export class RegistrationErrorPage extends Vue {


}



// WEBPACK FOOTER //
// ./src/pages/messages/registration-error/registration-error.ts